import * as yup from 'yup';
import { CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE, isCabysCoherentWithProductType } from '@utils/Cabys';

export const ProductFormSchema = yup.object().shape({
    codigo_cabys: yup.number().transform((value, originalValue) => {
        return originalValue === '' ? undefined : value;
    }).typeError('El codigo CABYS debe ser un número válido.')
        .required('El codigo CABYS es obligatorio').test(
            'cabys-13',
            'El codigo CABYS tiene que tener 13 digitos.',
            (value) => {
                const numberString = `${value}`
                if (numberString.length === 13) {
                    return true
                } else {
                    return false
                }
            }
        ).test(
            'cabys-tipo-producto',
            CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE,
            function (value) {
                return isCabysCoherentWithProductType(value, this.parent?.tipo_producto);
            }
        ),
    descripcion_fact: yup.string().required('La descripción para facturación es obligatoria.'),
    precio1: yup.number().moreThan(0, 'El precio debe ser mayor a 0.'),
});